<template>
    <div :class="containerClassName">
        <div class="shadow mb-12">
            <div class="bg-white border border-gray-200 border-t-0">
                <div class="border-b border-gray-200 flex" :class="titlePadding">
                    <h2 class="flex-1 text-xl font-thin text-gray-700  relative" @click="$emit('title-clicked')"><slot name="title"></slot></h2>
                    <slot name="after-title"></slot>
                    <a href="#" class="text-gray-500 hover:text-blue-600 transition-all duration-300 no-underline relative ml-4" @click.prevent="displaySearch = ! displaySearch" v-if="withSearch">
                        <i class="fas fa-search" :class="{'text-blue-600': displaySearch}"></i>
                    </a>
                    <router-link class="text-gray-500 hover:text-blue-600 transition-all duration-300 no-underline relative ml-4" :to="createLink" v-if="createLink">
                        <i class="fas fa-plus"></i>
                    </router-link>
                    <a href="#" class="text-gray-500 hover:text-blue-600 transition-all duration-300 no-underline relative ml-4" @click.prevent="bulkDelete" v-if="enableBulkDelete && selected.length > 0">
                        <i class="fas fa-trash-alt"></i>
                    </a>
                    <a href="#" class="text-gray-500 hover:text-blue-600 transition-all duration-300 no-underline relative ml-4" v-if="withMenu">
                        <i class="fas fa-ellipsis-h" @click.prevent="displayMenu = ! displayMenu"></i>
                        <div class="absolute right-0 pin-t-full bg-white shadow z-50 w-table-menu" v-if="displayMenu">
                            <slot name="menu"></slot>
                        </div>
                    </a>
                </div>
                <div class="border-b border-gray-20" v-if="displaySearch">
                    <input v-model="search" placeholder="Your search..." class="bg-gray-100 w-full hover:bg-gray-200 outline-none focus:border-blue px-6 py-4" />
                </div>
                <v-table-loader v-if="loading"></v-table-loader>
                <template v-else>
                    <slot name="content">
                        <v-table-empty v-if="empty"></v-table-empty>
                        <v-table-row :rowClass="rowClass" v-for="item in searchedData" :selected="isSelected(item)" :key="item.id" v-else>
                            <v-table-row-select :item="item" :selected="isSelected(item)" v-if="selectable" @clicked="toggleSelect"></v-table-row-select>
                            <slot :row="item" :selected="isSelected(item)">
                                <div class="px-4 w-16 font-normal">
                                    #{{ item.id }}
                                </div>
                                <div class="px-2 flex-1">
                                    {{ item.title }}
                                </div>
                            </slot>
                        </v-table-row>
                    </slot>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    import Loader from './Loader';
    import Empty from './Empty';
    import Row from './Row';
    import RowSelect from './RowSelect';

    export default {
        components: {
            'v-table-loader': Loader,
            'v-table-empty': Empty,
            'v-table-row': Row,
            'v-table-row-select': RowSelect
        },
        data() {
            return {
                search: '',
                selected: [],
                displaySearch: false,
                displayMenu: false
            }
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            data: {
                type: Array,
                default() {
                    return []
                }
            },
            withSearch: {
                type: Boolean,
                default: false,
            },
            searchableColumns: {
                type: Array,
                default() {
                    return ['id', 'title'];
                }
            },
            withMenu: {
                type: Boolean,
                default: false,
            },
            createLink: {
                type: Object,
                default: null
            },
            selectable: {
                type: Boolean,
                default: true,
            },
            enableBulkDelete: {
                type: Boolean,
                default: true,
            },
            bulkDeleteUrl: {
                type: String
            },
            rowClass: {
                type: String,
                default: 'flex w-full border-b border-gray-200 px-4 py-6 font-thin text-gray-600 relative hover:bg-gray-100 hover:shadow-row'
            },
            rowsContainerClass: {
                type: String,
                default: ''
            },
            containerClassName: {
                type: String,
                default: ''
            },
            filterMethod: {
                type: Function
            },
            filters: {},
            titlePadding: {
                type: String,
                default: 'p-6'
            }
        },

        computed: {
            empty() {
                return this.searchedData.length == 0;
            },
            searchedData() {
                if ( ! this.data ) {
                    return [];
                }

                if ( ! this.withSearch || ! this.displaySearch || this.search == '' ) {

                    if ( typeof this.filterMethod == 'function' ) {
                        return this.filterMethod(JSON.parse(JSON.stringify(this.data)));
                    }
                    return this.data;
                }

                let searchedData = [];

                for ( var i = 0; i < this.data.length; i++ ) {
                    var row = this.data[i];

                    for ( let n = 0; n < this.searchableColumns.length; n++ ) {
                        var column = this.searchableColumns[n];
                        var value = row[column];

                        if ( value === parseInt(value, 10) ) {
                            value = value.toString();
                        }

                        if ( value.toLowerCase().includes( this.search.toLowerCase() ) ) {
                            searchedData.push(row);
                            break;
                        }
                    }
                }

                if ( typeof this.filterMethod == 'function' ) {
                    searchedData = this.filterMethod(searchedData);
                }

                return searchedData;
            }
        },

        methods: {
            updateData() {
                let search = this.search;
                this.search = this.randomId();
                this.search = search;
            },
            
            toggleSelect(item)
            {
                for ( let i = 0; i < this.selected.length; i++ ) {
                    if ( this.selected[i].id == item.id ) {
                        this.selected.splice(i, 1);
                        return;
                    }
                }

                this.selected.push(item);
            },

            isSelected(item)
            {
                for ( let i = 0; i < this.selected.length; i++ ) {
                    if ( this.selected[i].id == item.id ) {
                        return true;
                    }
                }
                
                return false;
            },

            bulkDelete()
            {
                let confirm = window.prompt('Please enter "BULK DELETE" to confirm the deletion process.');
                if ( ! confirm || confirm !== 'BULK DELETE' ) {
                    window.Toasteo.info('Bulk deletion cancelled.');
                    return;
                }

                let ids = [];
                for ( let i = 0; i < this.selected.length; i++ ) {
                    ids.push(this.selected[i].id);
                }

                axios.post(this.bulkDeleteUrl, {ids: ids})
                    .then((response) => {
                        for ( let i = this.data.length- 1; i >=0; i-- ) {
                            for ( let n = 0; n < ids.length; n++ ) {

                                if ( this.data[i].id == ids[n] ) {
                                    this.data.splice(i, 1);
                                }
                            
                            }
                        }
                        window.Toasteo.success(response.data.message);
                    })
                    .catch((error) => {
                        window.Toasteo.info('An error happened while trying to delete rows');
                    });
            }
        }
    }
</script>
